


import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

const PieChart = ({ pieChart }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      datalabels: { display: false }, // no labels on chart
    },
  };

  return (
    <div>
      {/* 🔵 Chart CENTER */}
      <div
        className="mx-auto"
        style={{ height: "300px", width: "300px" }}
      >
        <Pie data={pieChart} options={options} />
      </div>

      {/* 🔽 Text LEFT (not centered) */}
      <ul className="list-unstyled mt-3 mb-0 w-100 text-start">
        {pieChart?.labels?.map((label, index) => (
          <li
            key={index}
            className="d-flex align-items-start mb-1"
          >
            <span
              style={{
                width: "12px",
                height: "12px",
                backgroundColor:
                  pieChart.datasets[0].backgroundColor[index],
                display: "inline-block",
                marginRight: "8px",
                marginTop: "4px",
                borderRadius: "2px",
                flexShrink: 0,
              }}
            ></span>

            <span>
              {label} – <span className="fw-bold">{pieChart.datasets[0].data[index]}%</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PieChart;
